/* eslint-disable @typescript-eslint/no-explicit-any */
import { Size } from '@ps/web-core-store';
import { format } from 'date-fns';
import React, { useEffect, useState } from 'react';

import { CMSHeading } from '@swf/cms';
import BaseModal from '@swf/components/StarsModal/BaseModal';
import CloseButton, { Variant } from '@swf/components/StarsModal/components/CloseButton';
import { fetchJson } from '@swf/core/utils/api';

// TODO refactor to use composition or shared.scss
// eslint-disable-next-line no-restricted-imports
import styles from '../Events.scss';

export interface EventInfo {
  title: string;
  onClose: () => void;
  winnersUrl: string;
  startDate: Date;
  buyin: string;
  orderId: string;
  players: string;
  prizePool: string;
  tour?: string;
  stop?: string;
}

export interface WinnerDetails {
  country: string;
  position: number;
  name: string;
  prize: string;
}

interface EventData {
  list: [
    {
      country: string;
      player: string;
      position: number;
      prize: string;
    }
  ];
}

const extractWinnerDetails = (data: EventData) =>
  data?.list?.map((item) => ({
    position: item.position,
    name: item.player,
    prize: item.prize,
    country: item.country
  })) as unknown as WinnerDetails[];

const EventModal: React.FC<EventInfo> = ({
  title,
  winnersUrl,
  startDate,
  orderId,
  prizePool,
  players,
  buyin,
  tour,
  stop,
  onClose
}) => {
  const [eventDetails, setEventDetails] = useState<WinnerDetails[]>([]);

  useEffect(() => {
    const abortController = new AbortController();
    const { signal } = abortController;

    const fetchData = async () => {
      try {
        const data = await fetchJson<EventData>(winnersUrl, { signal });
        setEventDetails(extractWinnerDetails(data));
      } catch {
        setEventDetails([]);
      }
    };

    fetchData();

    return () => abortController.abort();
  }, [winnersUrl]);

  return (
    <BaseModal className={styles.eventPopup} isOpen size={Size.LARGE} closeOnOverlayClick>
      <div className={styles.eventInfo}>
        <div className={styles.spacedBlock}>
          <CMSHeading
            title={`${tour} ${stop}`}
            level="h3"
            size="l"
            hero={false}
            alignment="center"
          />
        </div>
        <div className={styles.spacedBlock}>
          <CMSHeading title={`#${orderId} ${title}`} level="h3" size="l" hero={false} />
        </div>
        <CloseButton variant={Variant.Dark} onClick={onClose} />
        <div className={styles.eventDetailsBreakdown}>
          <ul className={styles.resultDetailsList}>
            <li>{format(new Date(startDate), 'yyyy-MM-dd')}</li>
            <li>
              <strong>Prize Pool</strong> – {prizePool}
            </li>
            <li>
              <strong>Buy-in</strong> – {buyin}
            </li>
            <li>
              <strong>Players</strong> – {players}
            </li>
          </ul>
        </div>
        <div className={styles.tableContainer}>
          <table className={styles.eventsTable}>
            <thead>
              <tr>
                <th>#</th>
                <th>Name</th>
                <th>Prize</th>
                <th>Country</th>
              </tr>
            </thead>
            <tbody>
              {eventDetails?.map((item, index) => (
                <tr key={index}>
                  <td>{item.position}</td>
                  <td>{item.name}</td>
                  <td>{item.prize}</td>
                  <td>{item.country}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </BaseModal>
  );
};

export default EventModal;
